import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { SharedService } from './shared.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private _svc: SharedService

  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    var access_token = "";
    if (localStorage.getItem('token') != null && localStorage.getItem('token') != 'undefined') {
      access_token = (localStorage.getItem('token') || "");
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${access_token}`
        }
      });
    }


    if (request.url.indexOf("FaceDetection") == -1)
      this._svc.Show_Loader();
    return next.handle(request).pipe(
      finalize(() => this._svc.Hide_Loader()),
    );
  }
}
